import React from 'react';
import {GridSkeleton} from '../../Skeleton';

export const UnfinishedTestResults = () => {
  return (
    <div className="test-inference-results__full-size-container">
      <GridSkeleton tileHeight={128} tileWidth={128} tileMarginX={14} tileMarginY={14} />
    </div>
  );
};
